import React, {useState} from 'react';

import { cf } from './c_20210415a_YSh/cf';
import { ce } from './c_20210415a_YSh/ce';
import { iv } from './c_20210415a_YSh/iv';
import { ic } from './c_20210415a_YSh/ic';
import { cp } from './c_20210415a_YSh/cp';
import { ip } from './c_20210415a_YSh/ip';
import { bf } from './c_20210415a_YSh/bf';

import cView from './c_20210415a_YSh/cView';

class iCmrList extends cView { // customer

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );

    bf.myCM_clw(60, () => { // 1分おきに表示を更新
      if ( this.state.sb_etr == true) {
        ip.$ip_load_it50({
          mode: 'get',
          cm20_key: this.state.sgcd_pageCmns?.cm20_key,
          it50s110: '10',
        })
        .then( async _d_is => {
          if ( _d_is.it50cy10 != this.state.s_it50cy10 ) {
            await this.load();
          };
          global.c?.setState({
            sld_it50ss: bf.p(global.c?.state.sld_it50ss, _next => {
              _next[0].it50cy10 = bf.myDT_get_now();
            })
          }, () => {
          });
        });
      };
    });
  }

  $ip_onEtr = () => new Promise( _o_end1 => {
    global.c?.setState({
      sb_etr: true,
    }, () => {
      _o_end1();
    })
  });

  $ip_onExit = () => new Promise( _o_end1 => {
    global.c?.setState({
      sb_etr: false,
    }, () => {
      _o_end1();
    })
  });

  $id_stss = {
    sld_it10ss: {},
//    s_dtm: bf.myDT_get_now(),
  };

  $ilp_bfrLoads = () => [
//    cp.$cp_load_cm10({ // スタッフ情報
    cp.$cp_hlr_cm10({ // スタッフ情報
      mode: 'items',
      cm20_key: global.c?.state.sgcd_pageCmns?.cm20_key,
      state: 'sld_cm10ss',
      b_wotDlt: true,
    }),
  ];

/*
  $ilp_loads = () => [
    new Promise( _o_end1 => { // 現在開設中のレジに紐づく入店情報のみを表示
      ip.$ip_load_it50({
        mode: 'get',
        cm20_key: global.c?.state.sgcd_pageCmns?.cm20_key,
        it50s110: '10',
      })
      .then( _d_it50s => {
        if (bf.f(_d_it50s)) {
          ip.$ip_load_it10({
            mode: 'items',
//            mode: 'clds',
            state: 'sld_it10ss',
            it50_key: _d_it50s._KEY,
            ld_sortss: [
              {
                fld: 'it10d110', 
                dtn: 'desc',
              }
            ],
          })
          .then(() => { 
            _o_end1();
          });
        }
        else {
          _o_end1();
        };
      });
    }),
  ];
*/  
  $ilp_loads = () => [
    new Promise( _o_end1 => { // 現在開設中のレジに紐づく入店情報のみを表示
/*
      ip.$ip_hlr_it50({
        mode: 'clds',
        state: 'sld_it50ss',
        cm20_key: global.c?.state.sgcd_pageCmns?.cm20_key,
        it50s110: '10',
      })
      .then( _ld_it50ss => {
        if (bf.f(_ld_it50ss)) {
          ip.$ip_hlr_it10({
            mode: 'clds',
            state: 'sld_it10ss',
            it50_key: _ld_it50ss[0]._KEY,
            do_rfrs: {
              im10: _d_is => bf.q('[_KEY]={}'.f(_d_is.it10b21k)),
            },
            ld_sortss: [
              {
                fld: 'it10d110', 
                dtn: 'desc',
              }
            ],
          })
          .then(() => { 
            _o_end1();
          });
        }
        else {
          _o_end1();
        };
      });
    }),
*/
      ip.$ip_hlr_it50({
        mode: 'clds',
        state: 'sld_it50ss',
        cm20_key: global.c?.state.sgcd_pageCmns?.cm20_key,
        it50s110: '10',
      })
      .then( _ld_it50ss => {
//bf.l('157: {}'.f(_ld_it50ss))
        if (bf.f(_ld_it50ss)) {
          ip.$ip_hlr_it10({
            mode: 'clds',
            state: 'sld_it10ss',
            //it50_key: _ld_it50ss[0]._KEY,
            cnd: bf.q('[it10b31k]="{}"'.f(_ld_it50ss[0]._KEY)),
            do_rfrs: {
              im10: _d_is => bf.q('[_KEY]={}'.f(_d_is.it10b21k)),
            },
            ld_sortss: [
              {
                fld: 'it10d110', 
                dtn: 'desc',
              }
            ],
          })
          .then(() => { 
            _o_end1();
          });
        }
        else {
          _o_end1();
        };
      });
    }),
    ip.$ip_load_it50({  // myCM_clw 用
      mode: 'set',
      cm20_key: global.c?.state.sgcd_pageCmns?.cm20_key,
      it50s110: '10',
    }),
  ];

  _onRhtPrs = () => {
    // レジの開設状況を確認し、閉まっている場合は顧客情報の新規登録を不可
    ip.chk_it50s110({
      cm20_key: global.c?.state.sgcd_pageCmns?.cm20_key,
      dtm: bf.myDT_get_now(),
    })
    .then((_d_it50s) => {
      if (bf.f(_d_it50s)) { // 開設中の場合
        cf.myRN_setCmns({
          it50_key: _d_it50s._KEY,
        })
        .then(() => {
          let _d_pageInfs = {
            sgc_pageRole: global.c?.state.sgc_pageRole,
            sgc_pageName: 'iCmrDtl',
            sgc_pageMode: 'new',
          };
          cf.myRN_move_fwd(_d_pageInfs);
        });
      }
      else { // 締切中の場合
        alert('レジが締まっているため、入店時刻情報を新規に登録できません。')
      };
    })
  };

  render() {
    return (
      <ce.RootDtl
        b_logo={false}
        b_sch={false}
        onSchEnt={null}
        b_rhtVsb={(global.c?.state.sgc_pageRole == 'own2') ? true : false }
        rhtIconName='plus'
        rhtPfx='新規'
        n_bdyW={ic.gn_w}
        onRhtPrs={global.c?._onRhtPrs}
        d_hdrs={{
          pfx: iv._get_hdrPfx((global.c?.state.sgc_pageRole == 'own2') ? '入店時刻一覧' : '実績一覧'),
          d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, cf.myNV_get_name(), global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName]),
          d_subMenus: {
            b_vsb: false,
          }
        }}
        d_bdys={{
          ld_defss: [
            {
              type: 'Clds',
              b_vsb: true,
              b_edt: false,
              state: 'sld_it50ss',
              pfx: '',
              b_hdr: false,
              b_row: true,
              b_ttl: true,
              b_spr: false,
              dd_defss: {
                it50cy10:{
                  type: 'Inp',
                  b_vsb: true,
                  b_edt: false,
                  pfx: '最終更新日時',
                  b_mln: false,
                  n_col: 7,
                  o_stlVal: pd => {
//                    return '{}'.f(pd.val).substr(11,5);
//                    return global.c?.state.s_dtm.substr(11,5);
                    return bf.myDT_get_now().substr(11,5);
                  },
                  ini: '0000-00-00 00:00:00',
                },
                it50i110:{
                  type: 'Inp',
                  b_vsb: true,
                  b_edt: false,
                  pfx: '大入設定額',
                  b_mln: false,
                  n_col: 7,
                  o_stlVal: pd => {
                    return bf.myCM_cnv('cmm', pd.val);
                  }
                },
                it50i210:{
                  type: 'Inp',
                  b_vsb: true,
                  b_edt: false,
                  pfx: '現在売上',
                  b_mln: false,
                  n_col: 7,
                  o_stlVal: pd => {
                    return bf.myCM_cnv('cmm', pd.val);
                  }
                },
                it50i120:{
                  type: 'Inp',
                  b_vsb: true,
                  b_edt: false,
                  pfx: '差額',
                  b_mln: false,
                  n_col: 7,
                  o_stlVal: pd => {
                    return bf.myCM_cnv('cmm', pd.val);
                  }
                },
                it50id30:{
                  type: 'Inp',
                  b_vsb: true,
                  b_edt: false,
                  pfx: '出勤者数',
                  b_mln: false,
                  n_col: 7,
                  onPrs: (pd_ids) => {
                    if (bf.f(global.c?.state.sld_it50ss)){
                      cf.myRN_setCmns({
                        it60_key: global.c?.state.sld_it50ss[0].it50b21k,
                        it50_key: global.c?.state.sld_it50ss[0]._KEY,
                      })
                      .then(() => {
                        let _d_pageInfs = {
                          sgc_pageRole: global.c?.state.sgc_pageRole,
                          sgc_pageName: 'iDayDtl',
                          sgc_pageMode: 'show',
                          sgcn_pageTab: 2,
                        };
                        cf.myRN_move_fwd(_d_pageInfs);
                      })
                    }
                  },
                  stlInp: {
                    fontSize: ic.gn_fontSizeNrm,
                    fontweight: 'bold',
                    color: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd,
                    textDecorationLine: 'underline',
                  }
                },
                it50i850:{
                  type: 'Inp',
                  b_vsb: true,
                  b_edt: false,
                  pfx: '現在組数',
                  b_mln: false,
                  n_col: 7,
                  ini: '0',
                },
                it50i860:{
                  type: 'Inp',
                  b_vsb: true,
                  b_edt: false,
                  pfx: '現在客数',
                  b_mln: false,
                  n_col: 7,
                  ini: '0',
                },
                it50i840:{
                  type: 'Inp',
                  b_vsb: true,
                  b_edt: false,
                  pfx: '現在延長率',
                  b_mln: false,
                  n_col: 7,
                  ini: '0',
                },
                it50id20:{
                  type: 'Inp',
                  b_vsb: true,
                  b_edt: false,
                  pfx: '内販責任者',
                  b_mln: false,
                  n_col: 10,
                  ld_itemss: global.c?.state.sld_cm10ss,
                },
                it50id10:{
                  type: 'Inp',
                  b_vsb: true,
                  b_edt: false,
                  pfx: '外販責任者',
                  b_mln: false,
                  n_col: 10,
                },
              },
              stlCta: {
//                height: ic.gn_fontSizeNrm * 2 + ic.gn_mgnNrm * 9 + ic.gn_bdrWNrm * 2,
              },
            },
            {
              type: 'Clds',
              b_vsb: true,
              b_edt: false,
              state: 'sld_it10ss',
              pfx: 'ヘッダー',
              b_row: true,
              b_hdr: true,
              b_ttl: false,
              b_withNo: true,
              b_spr: false,
              do_stlRows: _d_ids => {
                if ( _d_ids.d_vals?.it10s210 == '10') {
                  return {
                    backgroundColor: ic.g_ccdRP,
                  };
                }
              },
              dd_defss: {
                it10d110:{
                  type: 'Inp',
                  b_vsb: true,
                  b_edt: false,
                  pfx: '入店時刻',
                  b_mln: false,
                  n_col: 7,
                  o_stlVal: pd => {
                    return '{}'.f(pd.val).substr(11,5);
                  },
                  onPrs: (pd_ids) => {
//bf.l('309:{}'.f(pd_ids))
                    cf.myRN_setCmns({
                      it10_key: pd_ids.key,
                    })
                    .then(() => {
                      let _d_pageInfs = {
                        sgc_pageRole: global.c?.state.sgc_pageRole,
                        sgc_pageName: 'iCmrDtl',
                        sgc_pageMode: 'show',
                      };
                      cf.myRN_move_fwd(_d_pageInfs);
                    })
                  },
                  stlInp: {
                    fontSize: ic.gn_fontSizeNrm,
                    fontweight: 'bold',
                    color: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd,
                    textDecorationLine: 'underline',
                  }
                },
                it10d120:{
                  type: 'Inp',
                  b_vsb: true,
                  b_edt: false,
                  pfx: '終了予定時刻',
                  b_mln: false,
                  n_col: 7,
                  o_stlVal: pd => {
                    return '{}'.f(pd.val).substr(11,5);
                  },
                  do_stlInps: _d_ids => {
                    if (bf.n(_d_ids.d_vals?.it10i520) > 0) {
                      return {
                        backgroundColor: ic.g_ccdPP,
                      };
                    }
                  },
                },
                it10i410:{
                  type: 'Inp',
                  b_vsb: true,
                  b_edt: false,
                  pfx: '顧客名',
                  b_mln: false,
                  n_col: 7,
                },
                it10i330:{
                  type: 'Inp',
                  b_vsb: true,
                  b_edt: false,
                  pfx: '人数',
                  b_mln: false,
                  n_col: 7,
                },
                im10c310:{
                  type: 'Inp',
                  b_vsb: true,
                  b_edt: false,
                  pfx: 'バインダ番号',
                  b_mln: false,
                  n_col: 8,
                  onPrs: pd_ids => {
                    //alert('460:{}'.f(pd_ids))
                    ip.$ip_hlr_it10({
                      mode: 'upd',
                      d_vals: {
                        it10s210: '0',
                      },
                      cnd: bf.q('[_KEY]={}'.f(pd_ids.key)),
                    })
                    .then( () => {
                      global.c?.setState({
                        sld_it10ss: bf.p(global.c?.state.sld_it10ss, _next => {
                          _next[pd_ids.idx].it10s210 = '0';
                        }),
                      })
                    });
                  },
                  stlInp: {
                    fontSize: ic.gn_fontSizeNrm,
                    fontweight: 'bold',
                    color: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd,
                    textDecorationLine: 'underline',
                  }
                },
                it10ia70:{
                  type: 'Inp',
                  b_vsb: true,
                  b_edt: false,
                  pfx: '現在売上',
                  b_mln: false,
                  n_col: 7,
                  o_stlVal: pd => {
                    return bf.myCM_cnv('cmm', pd.val);
                  },
                  do_stlInps: _d_ids => {
                    if (bf.i(_d_ids.d_vals?.it10s110, ['0', '10'])) {
                      return {
                        backgroundColor: ic.g_ccdPP,
                      };
                    }
                  },
                },
                it10c310:{
                  type: 'Inp',
                  b_vsb: true,
                  b_edt: false,
                  pfx: '備考',
                  b_mln: false,
                  n_col: 20,
                },
              },
              stlCta: {
                height: ic.gn_bdyH - (ic.gn_fontSizeNrm * 2 + ic.gn_mgnNrm * 9 + ic.gn_bdrWNrm * 2),
              },
            }
          ]
        }}
      />
    );
  }

}

export default iCmrList;


